import Vue from 'vue'

export const mutations = {
  updateAttributes: (state, payload) => {
    const { presentationId, slideId, attributes } = payload
    if (!state[presentationId]) {
      Vue.set(state, presentationId, {})
    }
    if (!state[presentationId][slideId]) {
      Vue.set(state[presentationId], slideId, {})
    }
    Object.keys(attributes).forEach((key) => {
      Vue.set(state[presentationId][slideId], key, attributes[key])
    })
  },
}
